$.fn.nl_lib_autosize = function () {
    let elm = $(this);
    $.importScript(cdnjs.autosize,function () {
        autosize(elm);
    });
};